import { useState } from "react";

// Filtre cu buton „Aplică filtre”: ce alege utilizatorul stă în `draft`, iar lista se filtrează abia când
// apasă butonul (sau Enter) — atunci `draft` trece în `applied`. Implicit (`empty`) lista arată tot.
export default function useFilters(empty) {
  const [draft, setDraft] = useState(empty);
  const [applied, setApplied] = useState(empty);
  const same = (a, b) => JSON.stringify(a) === JSON.stringify(b);
  return {
    draft, applied,
    set: (patch) => setDraft(d => ({ ...d, ...patch })),
    apply: () => setApplied(draft),
    reset: () => { setDraft(empty); setApplied(empty); },
    // schimbare făcută de pagină (ex. luna următoare după închidere): ambele se actualizează
    setBoth: (patch) => { setDraft(d => ({ ...d, ...patch })); setApplied(a => ({ ...a, ...patch })); },
    dirty: !same(draft, applied),
    active: !same(applied, empty),
  };
}
